const NAME = "POLL_SETTINGS";

export default NAME;
